import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Box, Collapse } from 'wix-style-react';
import { AppContext } from '@src/context/store';
import { DataHooks } from '@src/constants/data-hooks';
import { TranslationKey } from '@src/types';
import { isDeclineAllEnabled } from '@src/context/selectors/ui-settings';
import { DeclineAllToggle } from './decline-all-toggle';
import { DeclineAllButtonEditor } from './decline-all-button-editor';

interface Props extends InjectedTranslateProps {
  enabled: boolean;
  inputValue: string;

  onToggleChange: (value: boolean) => void;
  onTextChange: (value: string) => void;

  learnMoreKBLink: string;
}

const DeclineAllComponent = ({ t, inputValue, enabled, onToggleChange, onTextChange, learnMoreKBLink }: Props) => {
  const store = React.useContext(AppContext);

  const declineAllEnabled = isDeclineAllEnabled(store);
  const tooltipProps = {
    tooltipText: t('text-and-display.add-decline-all-button.tooltip'),
    learnMoreText: t('learn.more'),
    learnMoreUrl: learnMoreKBLink,
  };

  let declineAllButtonText = inputValue;
  if (declineAllButtonText == null) {
    declineAllButtonText = t(TranslationKey.DeclineAllButton);
    onTextChange(declineAllButtonText);
  }

  return (
    <Box direction={'vertical'}>
      <DeclineAllToggle
        initialState={enabled}
        text={t('text-and-display.add-decline-all-button.title')}
        tooltipProps={tooltipProps}
        dataHook={DataHooks.TextAndDisplayDeclineAllToggle}
        onChange={onToggleChange}
      />
      <Collapse open={declineAllEnabled}>
        <Box>
          <DeclineAllButtonEditor value={declineAllButtonText} onChange={onTextChange} />
        </Box>
      </Collapse>
    </Box>
  );
};

export const DeclineAllContainer = translate()(DeclineAllComponent);
